var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { UtilitiesContext, Loader, Row, Col, Icon, NoResults, DotsLoader, Well } from "@brushfire/ui";
import { getEventList } from "../../../data/api";
import EventMapCard from "./EventMapCard";
import { debounce } from "lodash";
import moment from "moment";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import Skeleton from "@material-ui/lab/Skeleton";
import Constants from "../../../data/constants";
import * as qs from "query-string";
import { setInlineError } from "../../../store/AppState/actions";
import InlineError from "../../UI/InlineError";
import { handleErrors, log, platformAwareRedirect, Style } from "../../../data/helpers";
import useWidgetAnalytics from "../../../hooks/useWidgetAnalytics";
import { getLocal, LOCAL_STORAGE_KEYS, setLocal } from "../../../data/localStorageHelpers";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import { WidgetContext } from "../../Widget";
import { useSpecificBFPayment } from "../../../hooks/useSpecificBFPayment";
import { SearchBox } from "@mapbox/search-js-react";
import { useMediaQuery } from "react-responsive";
var useTypedSelector = useSelector;
var EventMap = function (_a) {
    var _b, _c, _d;
    var theme = _a.theme, isWidget = _a.isWidget;
    var _e = __read(useState(false), 2), isLoaded = _e[0], setIsLoaded = _e[1];
    var _f = __read(useState(true), 2), isFetchingEventList = _f[0], setIsFetchingEventList = _f[1];
    var _g = __read(useState(false), 2), displayMap = _g[0], setDisplayMap = _g[1];
    var _h = __read(useState(), 2), position = _h[0], setPosition = _h[1];
    var _j = __read(useState(""), 2), searchAddress = _j[0], setSearchAddress = _j[1];
    var _k = __read(useState(true), 2), mapIsLoading = _k[0], setMapIsLoading = _k[1];
    var _l = __read(useState([]), 2), eventList = _l[0], setEventList = _l[1];
    var _m = __read(useState([]), 2), filteredEventList = _m[0], setFilteredEventList = _m[1];
    var _o = __read(useState(), 2), headScripts = _o[0], setHeadScripts = _o[1];
    var _p = __read(useState(), 2), bodyScripts = _p[0], setBodyScripts = _p[1];
    var _q = __read(useState(), 2), selectedMapEvent = _q[0], setSelectedMapEvent = _q[1];
    var _r = __read(useState(), 2), bounds = _r[0], setBounds = _r[1];
    var _s = __read(useState(false), 2), isSearchReady = _s[0], setIsSearchReady = _s[1];
    var client = useTypedSelector(function (store) { return store.clients; }).client;
    var _t = useTypedSelector(function (store) { return store.utilities; }), localization = _t.localization, utilitiesStatus = _t.utilitiesStatus, constants = _t.constants;
    var isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    var eventsWithLocations = eventList.filter(function (e) { return !!e.latitude && !!e.longitude; });
    var route = useRouteMatch();
    var _u = route.params, clientKey = _u.clientKey, urlKey = _u.urlKey;
    var history = useHistory();
    var widgetHistory = useWidgetHistory();
    var dispatch = useDispatch();
    var location = useLocation();
    var search = location.search.toLowerCase();
    var access = (_b = new URLSearchParams(search).get("access")) !== null && _b !== void 0 ? _b : "";
    var promo = (_c = new URLSearchParams(search).get("promo")) !== null && _c !== void 0 ? _c : "";
    // Set payment cookie depending on path
    useSpecificBFPayment();
    var analytics = useWidgetAnalytics();
    var gaSessions = useContext(WidgetContext).gaSessions;
    useEffect(function () {
        setIsSearchReady(true);
    }, [route]);
    var average = function (array) { return array.reduce(function (a, b) { return a + b; }) / array.length; };
    useEffect(function () {
        navigator.geolocation.getCurrentPosition(function (position) {
            setPosition({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            });
        }, function (err) {
            fetch("https://extreme-ip-lookup.com/json/?key=Kb8gWxelFPTSGbUJOlHn")
                .then(function (res) { return res.json(); })
                .then(function (response) {
                var pos = {
                    lat: response.lat,
                    lng: response.lon,
                };
                setPosition(pos);
            })
                .catch(function () {
                //TODO global error
                log("Request failed", Style.error);
            });
        });
        setDisplayMap(true);
    }, [navigator]);
    useEffect(function () {
        if (promo) {
            var localPromo = getLocal(LOCAL_STORAGE_KEYS.PROMO);
            if (promo !== "" && localPromo !== promo) {
                setLocal("".concat(LOCAL_STORAGE_KEYS.PROMO), promo, 60 * 60 * 24);
            }
        }
    }, [promo]);
    useEffect(function () {
        if (access) {
            if (access !== "") {
                setLocal("".concat(LOCAL_STORAGE_KEYS.ACCESS), access, 60 * 60 * 24);
            }
        }
    }, [access]);
    var fetchData = function (clientKey, urlKey, search, startsat, endsat, category) {
        if (clientKey) {
            setIsFetchingEventList(true);
            var isRedirecting_1 = false;
            getEventList(clientKey, urlKey, search, startsat ? moment(startsat).toISOString() : undefined, endsat
                ? moment(endsat)
                    .add(1, "day")
                    .subtract(1, "second")
                    .toISOString()
                : undefined, category)
                .then(function (_a) {
                var data = _a.data;
                setHeadScripts(data.customHeadCodes.concat(data.cartStackTrackings));
                setBodyScripts(data.customBodyCodes);
                if (data.events.length === 1 &&
                    !isLoaded &&
                    (!search || search === "") &&
                    !startsat &&
                    !endsat &&
                    !category) {
                    var event_1 = data.events[0];
                    platformAwareRedirect(Constants.Routes.map
                        .replace(":clientKey", event_1.clientKey)
                        .replace(":urlKey", event_1.urlKey), false, widgetHistory);
                    isRedirecting_1 = true;
                }
                else {
                    var parsed = qs.parse(window.location.search.toLowerCase());
                    var stringified = qs.stringify(__assign(__assign({}, parsed), { search: search, startsat: startsat !== null && startsat !== void 0 ? startsat : undefined, endsat: endsat !== null && endsat !== void 0 ? endsat : undefined, category: category !== null && category !== void 0 ? category : undefined }));
                    history.push({ search: stringified });
                    setEventList(data.events);
                }
                var eventGoogleAnalyticsProperties = [];
                data.googleTrackings.forEach(function (googleTracking) {
                    if (googleTracking.toUpperCase().startsWith("UA-")) {
                        eventGoogleAnalyticsProperties.push({
                            number: googleTracking,
                            domain: "",
                        });
                    }
                    else if (googleTracking.toUpperCase().startsWith("[{")) {
                        var trackings = JSON.parse(googleTracking);
                        trackings.forEach(function (tracking) {
                            if (!eventGoogleAnalyticsProperties.find(function (g) { return g.number === tracking.number; })) {
                                eventGoogleAnalyticsProperties.push(tracking);
                            }
                        });
                    }
                });
                eventGoogleAnalyticsProperties.forEach(function (googleProperty) {
                    var domains = googleProperty.domain.split(",");
                    if (!domains.includes(window.widgetHost)) {
                        domains.push(window.widgetHost);
                    }
                    if (gaSessions[googleProperty.number]) {
                        if (window.brushfireDebugMode === "true" || window.brushfireDebugMode === true) {
                            console.log("Connecting to Google Analytics session with client id \"".concat(gaSessions[googleProperty.number].clientId, "\" and session id \"").concat(gaSessions[googleProperty.number].sessionId, "\""));
                        }
                        gtag("config", googleProperty.number, {
                            groups: "eventListProperties",
                            send_page_view: false,
                            linker: googleProperty.domain !== ""
                                ? {
                                    domains: domains,
                                }
                                : undefined,
                            client_id: gaSessions[googleProperty.number].clientId,
                            session_id: gaSessions[googleProperty.number].sessionId,
                        });
                    }
                    else {
                        gtag("config", googleProperty.number, {
                            groups: "eventListProperties",
                            send_page_view: false,
                            linker: googleProperty.domain !== ""
                                ? {
                                    domains: domains,
                                }
                                : undefined,
                        });
                    }
                });
                gtag("event", "page_view", { send_to: "eventListProperties" });
                var eventFacebookIds = [];
                data.facebookTrackings.forEach(function (facebookTracking) {
                    var trackings = facebookTracking.split("|");
                    trackings.forEach(function (tracking) {
                        if (!eventFacebookIds.includes(tracking)) {
                            eventFacebookIds.push(tracking);
                        }
                    });
                });
                if (eventFacebookIds.length) {
                    analytics.setFacebookIds(eventFacebookIds);
                }
                analytics.logPageview();
            })
                .catch(function (err) {
                var _a, _b;
                handleErrors(err, dispatch, undefined, undefined, true);
                if ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                    dispatch(setInlineError({ getEventList: err.response.data.message }));
                }
            })
                .finally(function () {
                if (!isRedirecting_1) {
                    setIsFetchingEventList(false);
                    setIsLoaded(true);
                }
            });
        }
    };
    useEffect(function () {
        var scriptsAdded = [];
        if (headScripts) {
            headScripts.forEach(function (customHeadCode) {
                var dom = new DOMParser().parseFromString(customHeadCode, "text/html");
                var scripts = dom.documentElement.querySelectorAll("script");
                scripts.forEach(function (el) {
                    if (el === null || el === void 0 ? void 0 : el.src) {
                        var script = document.createElement("script");
                        if (el.hasAttributes()) {
                            for (var i = 0; i < el.attributes.length; i++) {
                                var attr = el.attributes[i];
                                script.setAttribute(attr.name, attr.value);
                            }
                        }
                        //TODO add these in once log helper method is added back
                        // script.addEventListener("load", function() {
                        // 	console.log("Loaded external script");
                        // });
                        // script.addEventListener("error", function() {
                        // 	console.log("Error loading external script");
                        // });
                        document.head.appendChild(script);
                    }
                    else {
                        if (el.textContent) {
                            try {
                                eval(el.textContent);
                            }
                            catch (e) {
                                console.error("Error executing the following script:");
                                console.error(el.textContent);
                            }
                        }
                    }
                });
            });
        }
        return function () {
            scriptsAdded.forEach(function (script) {
                script.remove();
            });
        };
    }, [headScripts]);
    useEffect(function () {
        var scriptsAdded = [];
        if (bodyScripts) {
            bodyScripts.forEach(function (customBodyCode) {
                var dom = new DOMParser().parseFromString(customBodyCode, "text/html");
                var scripts = dom.documentElement.querySelectorAll("script");
                scripts.forEach(function (el) {
                    if (el === null || el === void 0 ? void 0 : el.src) {
                        var script = document.createElement("script");
                        if (el.hasAttributes()) {
                            for (var i = 0; i < el.attributes.length; i++) {
                                var attr = el.attributes[i];
                                script.setAttribute(attr.name, attr.value);
                            }
                        }
                        //TODO add these in once log helper method is added back
                        // script.addEventListener("load", function() {
                        // 	console.log("Loaded external script");
                        // });
                        // script.addEventListener("error", function() {
                        // 	console.log("Error loading external script");
                        // });
                        scriptsAdded.push(script);
                        document.body.appendChild(script);
                    }
                    else {
                        if (el.textContent) {
                            try {
                                eval(el.textContent);
                            }
                            catch (e) {
                                console.error("Error executing the following script:");
                                console.error(el.textContent);
                            }
                        }
                    }
                });
            });
        }
        return function () {
            scriptsAdded.forEach(function (script) {
                script.remove();
            });
        };
    }, [bodyScripts]);
    var debounceLoadData = useCallback(debounce(fetchData, 1000), []);
    useEffect(function () {
        if (isSearchReady)
            debounceLoadData(clientKey, urlKey);
    }, [clientKey, urlKey, isSearchReady]);
    useEffect(function () {
        if (!!eventsWithLocations && bounds) {
            var filteredEvents = eventsWithLocations
                .filter(function (evt) {
                // filter what's in view
                if (isWithinBounds(evt.latitude, evt.longitude, bounds)) {
                    return evt;
                }
            })
                .map(function (filteredEvt) {
                var _a, _b;
                return __assign(__assign({}, filteredEvt), { distanceFromCenter: calculateDistance((_a = position === null || position === void 0 ? void 0 : position.lat) !== null && _a !== void 0 ? _a : 39.8282, (_b = position === null || position === void 0 ? void 0 : position.lng) !== null && _b !== void 0 ? _b : -98.5795, filteredEvt.latitude, filteredEvt.longitude) });
            })
                .sort(function (evt1, evt2) {
                // sort it by distance
                return evt1.distanceFromCenter - evt2.distanceFromCenter;
            });
            setFilteredEventList(filteredEvents);
        }
    }, [eventList, bounds]);
    var onLoad = useCallback(function (map) {
        var bounds = new window.google.maps.LatLngBounds();
        if (position) {
            bounds.extend(new window.google.maps.LatLng(position.lat, position.lng));
            var closestEvent = findClosestEvent(position, eventsWithLocations);
            if (closestEvent) {
                var place = new window.google.maps.LatLng(closestEvent.latitude, closestEvent.longitude);
                bounds.extend(place);
                map.fitBounds(bounds);
            }
            // wait for the map to finish loading
            window.google.maps.event.addListenerOnce(map, "idle", function () {
                var _a;
                var calculatedZoom = (_a = map.getZoom()) !== null && _a !== void 0 ? _a : 8;
                // set the center and zoom
                map.setCenter(new window.google.maps.LatLng(position.lat, position.lng));
                map.setZoom(calculatedZoom - 1);
                setBounds(map.getBounds());
            });
            // add an event listener on zoom and pan so we can adjust the bounds and the filtered list of events dynamically
            google.maps.event.addListener(map, "zoom_changed", function () {
                var zoomChangeBoundsListener = google.maps.event.addListener(map, "bounds_changed", function () {
                    setBounds(map.getBounds());
                    google.maps.event.removeListener(zoomChangeBoundsListener);
                });
            });
            google.maps.event.addListener(map, "center_changed", function () {
                var zoomChangeBoundsListener = google.maps.event.addListener(map, "bounds_changed", function () {
                    setBounds(map.getBounds());
                    google.maps.event.removeListener(zoomChangeBoundsListener);
                });
            });
        }
        else {
            map.setCenter(new window.google.maps.LatLng(!!eventsWithLocations.length ? average(eventsWithLocations.map(function (e) { return e.latitude; })) : 39.8282, !!eventsWithLocations.length ? average(eventsWithLocations.map(function (e) { return e.longitude; })) : -98.5795));
            map.setZoom(8);
            // if location access wasn't granted, lets default to the original behavior
            eventsWithLocations.forEach(function (e) {
                //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                var place = new window.google.maps.LatLng(e.latitude, e.longitude);
                bounds.extend(place);
            });
            map.fitBounds(bounds);
            // wait for the map to finish loading
            window.google.maps.event.addListenerOnce(map, "idle", function () {
                var _a;
                var calculatedZoom = (_a = map.getZoom()) !== null && _a !== void 0 ? _a : 8;
                // set the center and zoom
                map.setCenter(new window.google.maps.LatLng(!!eventsWithLocations.length
                    ? average(eventsWithLocations.map(function (e) { return e.latitude; }))
                    : 39.8282, !!eventsWithLocations.length
                    ? average(eventsWithLocations.map(function (e) { return e.longitude; }))
                    : -98.5795));
                map.setZoom(calculatedZoom);
                setBounds(map.getBounds());
            });
            // add an event listener on zoom and pan so we can adjust the bounds and the filtered list of events dynamically
            google.maps.event.addListener(map, "zoom_changed", function () {
                var zoomChangeBoundsListener = google.maps.event.addListener(map, "bounds_changed", function () {
                    setBounds(map.getBounds());
                    google.maps.event.removeListener(zoomChangeBoundsListener);
                });
            });
            google.maps.event.addListener(map, "center_changed", function () {
                var zoomChangeBoundsListener = google.maps.event.addListener(map, "bounds_changed", function () {
                    setBounds(map.getBounds());
                    google.maps.event.removeListener(zoomChangeBoundsListener);
                });
            });
        }
        // custom zoom controls since options.zoomControl isn't working...
        var zoomInButton = document.querySelector(".zoom-in");
        var zoomOutButton = document.querySelector(".zoom-out");
        if (zoomInButton) {
            zoomInButton.addEventListener("click", function () {
                var zoom = map.getZoom();
                if (typeof zoom === "number") {
                    map.setZoom(zoom + 1);
                }
            });
        }
        if (zoomOutButton) {
            zoomOutButton.addEventListener("click", function () {
                var zoom = map.getZoom();
                if (typeof zoom === "number") {
                    map.setZoom(zoom - 1);
                }
            });
        }
        setMapIsLoading(false);
    }, [position, eventsWithLocations]);
    if (!isLoaded || utilitiesStatus.isLoading) {
        return (_jsx(Loader, { customLoadingIcon: _jsx(DotsLoader, { containerClasses: "global-loader-container" }), classes: "global-loader" }));
    }
    var infoWindowButton = function (event) {
        if (event.soldOut) {
            return _jsx(_Fragment, { children: "Sold Out" });
        }
        else if (event.verbiage === "TIX") {
            return (_jsxs(_Fragment, { children: [_jsx(Icon, { icon: "ticket-alt" }), " Get Tickets"] }));
        }
        else {
            return (_jsxs(_Fragment, { children: [_jsx(Icon, { icon: "list-alt" }), " Register"] }));
        }
    };
    // haversine formula
    // https://stackoverflow.com/questions/18883601/function-to-calculate-distance-between-two-coordinates
    var calculateDistance = function (lat1, lng1, lat2, lng2) {
        var R = 6371; // Radius of the earth in km
        var dLat = ((lat2 - lat1) * Math.PI) / 180;
        var dLng = ((lng2 - lng1) * Math.PI) / 180;
        var a = 0.5 -
            Math.cos(dLat) / 2 +
            (Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * (1 - Math.cos(dLng))) / 2;
        return R * 2 * Math.asin(Math.sqrt(a)); // distance in km
    };
    var findClosestEvent = function (center, events) {
        var closestEvent = events[0];
        var minDistance = Infinity;
        events.forEach(function (event) {
            var distance = calculateDistance(center.lat, center.lng, event.latitude, event.longitude);
            if (distance < minDistance) {
                minDistance = distance;
                closestEvent = event;
            }
        });
        return closestEvent;
    };
    var isWithinBounds = function (lat, lng, bounds) {
        return bounds.contains({ lat: lat, lng: lng });
    };
    var getDistanceAwayInMiles = function (evt) {
        var _a, _b;
        var distanceInKm = calculateDistance((_a = position === null || position === void 0 ? void 0 : position.lat) !== null && _a !== void 0 ? _a : 39.8282, (_b = position === null || position === void 0 ? void 0 : position.lng) !== null && _b !== void 0 ? _b : -98.5795, evt.latitude, evt.longitude);
        var miles = distanceInKm / 1.609344;
        return isMobile ? "".concat(Math.ceil(miles), " mi away from you") : "".concat(Math.ceil(miles), " mi");
    };
    return (_jsx("div", __assign({ className: "page-body ta-left ".concat(isWidget ? "widget" : "") }, { children: _jsx(UtilitiesContext.Provider, __assign({ value: { localization: localization } }, { children: _jsx(IntlProvider, __assign({ locale: (_d = client === null || client === void 0 ? void 0 : client.culture) !== null && _d !== void 0 ? _d : "en-US" }, { children: _jsx(Well, __assign({ className: "".concat(isWidget ? "" : "m-bottom-x-large", " well-lg mt-0-sm border-radius-sm-0 event-list-well") }, { children: _jsxs(_Fragment, { children: [isFetchingEventList ? (_jsx(Row, { children: _jsx(Col, __assign({ sm: 12 }, { children: _jsx(Skeleton, { variant: "rect", animation: "wave", width: "100%", className: "field-skeleton mb-1" }) })) })) : (_jsx(Row, { children: _jsx(Col, __assign({ lg: 12 }, { children: _jsx("div", __assign({ className: "field map-search", style: { marginBottom: "10px" } }, { children: _jsx(SearchBox, { accessToken: "pk.eyJ1IjoiYnJ1c2hmaXJlbWFwcyIsImEiOiJjbDR5bDZmNDgyemhtM29xejZycnM2ZDh1In0.hKM61GLzF2f831lznC0KoQ", onSuggest: function () {
                                                if (selectedMapEvent) {
                                                    setSelectedMapEvent(undefined);
                                                }
                                            }, onRetrieve: function (response) {
                                                if (selectedMapEvent) {
                                                    setSelectedMapEvent(undefined);
                                                }
                                                if (response) {
                                                    setSearchAddress(response.features[0].properties.full_address);
                                                    setPosition({
                                                        lat: response.features[0].geometry.coordinates[1],
                                                        lng: response.features[0].geometry.coordinates[0],
                                                    });
                                                }
                                            }, options: {
                                                proximity: position,
                                                types: new Set([
                                                    "locality",
                                                    "country",
                                                    "region",
                                                    "postcode",
                                                    "district",
                                                    "neighborhood",
                                                    "street",
                                                    "address",
                                                    "block",
                                                    "place",
                                                ]), // need to explicitly give all types b/c it excludes brands, categories, places etc
                                            }, value: searchAddress, placeholder: "Enter an address to find events in your area", theme: {
                                                icons: {
                                                    search: "", // this messes up with our css
                                                },
                                                variables: {
                                                    fontFamily: "ff-basic-gothic-pro, sans-serif",
                                                },
                                            } }) })) })) })), _jsx(InlineError, { id: "getEventList" }), eventList.length > 0 && !isFetchingEventList && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: mapIsLoading || !displayMap ? "hide" : "" }, { children: _jsxs(GoogleMap, __assign({ id: "bf_map", mapContainerStyle: !isMobile
                                                ? { width: "100%", height: "550px", zIndex: 99 }
                                                : { width: "100%", height: "225px", zIndex: 99 }, onLoad: function (map) {
                                                onLoad(map);
                                            } }, { children: [_jsxs("div", __assign({ className: "zoom-control" }, { children: [_jsx("button", __assign({ className: "zoom-in zoom-button" }, { children: "+" })), _jsx("button", __assign({ className: "zoom-out zoom-button" }, { children: "-" }))] })), eventsWithLocations === null || eventsWithLocations === void 0 ? void 0 : eventsWithLocations.map(function (event) { return (_jsx(Marker, __assign({ position: {
                                                        lat: event.latitude,
                                                        lng: event.longitude,
                                                    }, onClick: function () {
                                                        setSelectedMapEvent(event);
                                                    } }, { children: _jsx(_Fragment, { children: (selectedMapEvent === null || selectedMapEvent === void 0 ? void 0 : selectedMapEvent.eventNumber) === event.eventNumber && (_jsx(InfoWindow, __assign({ position: {
                                                                lat: event.latitude,
                                                                lng: event.longitude,
                                                            }, onCloseClick: function () {
                                                                setTimeout(function () {
                                                                    setSelectedMapEvent(undefined);
                                                                }, 300);
                                                            } }, { children: _jsxs("div", __assign({ style: {
                                                                    maxWidth: "400px",
                                                                    minHeight: "100px",
                                                                    overflow: "hidden",
                                                                }, className: "map-tooltip" }, { children: [_jsx(Row, { children: _jsxs(Col, __assign({ xs: 12, className: "pl-3 pr-5" }, { children: [_jsx("h4", __assign({ className: "pt-2" }, { children: event.title })), event.isSticky ||
                                                                                    (event.soldOut && (_jsx("div", { children: _jsxs("small", { children: [event.isSticky && (_jsx("span", __assign({ className: "label label-info" }, { children: "FEATURED" }))), event.soldOut && (_jsx("span", __assign({ className: "label label-danger" }, { children: "SOLD OUT" })))] }) }))), !!event.dateInfo && (_jsxs("div", __assign({ className: "pb-2" }, { children: [_jsx("i", { className: "fal fa-fw fa-calendar-alt" }), " ", event.dateInfo] }))), !!event.locationName && (_jsxs("div", __assign({ className: "pb-2" }, { children: [_jsx("i", { className: "fal fa-fw fa-map-marker-alt" }), " ", event.locationName] }))), !!position && (_jsxs("div", __assign({ className: "pb-2" }, { children: [_jsx("i", { className: "fal fa-fw fa-route" }), " ", getDistanceAwayInMiles(event)] })))] })) }), _jsx(Row, { children: _jsx(Col, __assign({ xs: 12 }, { children: _jsx("a", __assign({ className: "btn m-top btn-block  btn-".concat(event.soldOut ? "danger" : "primary", " display-block"), href: Constants.Routes.eventStart
                                                                                    .replace(":clientKey", event.clientKey)
                                                                                    .replace(":urlKey", event.urlKey)
                                                                                    .replace(":eventNumber", event.eventNumber.toString()) }, { children: infoWindowButton(event) })) })) })] })) }))) }) }), event === null || event === void 0 ? void 0 : event.eventNumber)); })] }), "".concat(position === null || position === void 0 ? void 0 : position.lat, "-").concat(position === null || position === void 0 ? void 0 : position.lng)) })), mapIsLoading && (_jsx(Skeleton, { variant: "rect", animation: "wave", height: 400, width: "100%" })), (mapIsLoading || !displayMap) && (_jsx(DotsLoader, { containerClasses: "d-flex justify-content-center mt-3" }))] })), filteredEventList.length > 0 ? (_jsx("div", __assign({ className: "event-map-card-results ".concat(isFetchingEventList ? "fetching" : "") }, { children: filteredEventList === null || filteredEventList === void 0 ? void 0 : filteredEventList.map(function (event) { return (_jsx(EventMapCard, { event: event, isWidget: isWidget, isLoading: isFetchingEventList, distance: position ? getDistanceAwayInMiles(event) : "" }, event.eventNumber)); }) }))) : (_jsxs(NoResults, __assign({ className: "m-top-large", icon: "search", iconWeight: "duotone" }, { children: [_jsx("h4", { children: "No events in map area" }), "Try entering a different address"] })))] }) })) })) })) })));
};
export default EventMap;
